var _metadata, _defs, _style;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGandhLogo = function SvgGandhLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.93 566.93",
    style: {
      enableBackground: "new 0 0 566.93 566.93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata90"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "v1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.93,566.62H0V-0.31h566.93V566.62z",
    id: "path4",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Balken_5_",
    x: 88.52,
    y: 494.35,
    className: "st0",
    width: 389.89,
    height: 2.79,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "DIE_FRISCHEMACHER_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g38",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.53,460.64c0,1.95-0.37,3.77-1.09,5.48c-0.73,1.7-1.73,3.19-3.01,4.47s-2.77,2.28-4.47,3.01     c-1.7,0.73-3.53,1.09-5.48,1.09H98.3v-28.11h8.18c1.95,0,3.77,0.36,5.48,1.09c1.7,0.73,3.19,1.73,4.47,3.01     c1.28,1.28,2.28,2.77,3.01,4.47C120.17,456.87,120.53,458.69,120.53,460.64z M115.79,460.64c0-1.29-0.24-2.5-0.73-3.63     c-0.49-1.13-1.15-2.12-1.99-2.96c-0.84-0.84-1.83-1.5-2.96-1.99c-1.13-0.49-2.34-0.73-3.63-0.73h-3.43v18.62h3.43     c1.29,0,2.5-0.24,3.63-0.73c1.13-0.49,2.12-1.15,2.96-1.99c0.84-0.84,1.5-1.83,1.99-2.96     C115.54,463.14,115.79,461.93,115.79,460.64z",
    id: "path7",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.71,474.7h-4.75v-28.11h4.75V474.7z",
    id: "path9",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.94,474.7h-17.52v-28.11h17.52v4.75h-12.78v6.94h11.32v4.75h-11.32v6.94h12.78V474.7z",
    id: "path11",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.33,451.33h-12.78v6.94h11.32v4.75h-11.32v11.68h-4.75v-28.11h17.52V451.33z",
    id: "path13",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.51,474.7h-5.48l-5.84-11.68h-3.4v11.68h-4.75v-28.11h11.06c1.12,0,2.18,0.21,3.18,0.64     c1,0.43,1.87,1.02,2.63,1.77c0.75,0.75,1.34,1.63,1.77,2.63c0.43,1,0.64,2.06,0.64,3.18c0,0.93-0.15,1.81-0.44,2.67     c-0.29,0.85-0.71,1.62-1.24,2.32c-0.54,0.69-1.17,1.3-1.92,1.81c-0.74,0.51-1.56,0.89-2.46,1.13L210.51,474.7z M205.58,454.8     c0-0.46-0.09-0.91-0.27-1.33c-0.18-0.42-0.43-0.8-0.75-1.11c-0.32-0.32-0.69-0.57-1.11-0.75c-0.43-0.18-0.87-0.27-1.33-0.27     h-6.32v6.94h6.32c0.46,0,0.91-0.09,1.33-0.27c0.43-0.18,0.8-0.43,1.11-0.75c0.32-0.32,0.57-0.68,0.75-1.1     C205.49,455.74,205.58,455.29,205.58,454.8z",
    id: "path15",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.97,474.7h-4.75v-28.11h4.75V474.7z",
    id: "path17",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.19,466.92c0,1.29-0.26,2.44-0.77,3.45c-0.51,1.01-1.19,1.86-2.04,2.56c-0.85,0.69-1.84,1.22-2.96,1.59     c-1.12,0.37-2.29,0.55-3.51,0.55c-2.04,0-3.8-0.57-5.26-1.72c-1.46-1.14-2.51-2.67-3.14-4.56l4.02-1.79     c0.34,0.95,0.8,1.69,1.37,2.21c0.57,0.52,1.19,0.88,1.84,1.08c0.66,0.2,1.33,0.24,2.01,0.13c0.68-0.11,1.3-0.32,1.84-0.64     c0.55-0.32,0.99-0.72,1.33-1.22c0.34-0.5,0.51-1.04,0.51-1.62c0-0.75-0.28-1.39-0.84-1.9c-0.56-0.51-1.27-1-2.12-1.46     c-0.85-0.46-1.77-0.93-2.76-1.41c-0.99-0.47-1.9-1.05-2.76-1.73c-0.85-0.68-1.56-1.5-2.12-2.46c-0.56-0.96-0.84-2.16-0.84-3.6     c0-1.1,0.2-2.13,0.6-3.1c0.4-0.97,0.96-1.84,1.68-2.59c0.72-0.75,1.56-1.35,2.52-1.79c0.96-0.44,1.99-0.66,3.08-0.66     c1.75,0,3.29,0.44,4.6,1.33c1.31,0.89,2.32,2.12,3.03,3.71l-4.13,1.9c-0.46-0.97-1.09-1.63-1.88-1.97     c-0.79-0.34-1.56-0.43-2.32-0.27c-0.75,0.16-1.41,0.54-1.97,1.15c-0.56,0.61-0.84,1.38-0.84,2.3c0,0.73,0.29,1.35,0.88,1.86     c0.58,0.51,1.31,0.99,2.19,1.42c0.88,0.44,1.82,0.9,2.83,1.39c1.01,0.49,1.95,1.07,2.83,1.75c0.88,0.68,1.61,1.51,2.19,2.5     C239.9,464.27,240.19,465.48,240.19,466.92z",
    id: "path19",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.4,450.31l-3.4,3.4c-0.9-0.85-1.93-1.51-3.08-1.97c-1.16-0.46-2.35-0.69-3.6-0.69     c-1.34,0-2.59,0.25-3.76,0.75c-1.17,0.5-2.19,1.19-3.07,2.06c-0.88,0.88-1.56,1.9-2.06,3.07c-0.5,1.17-0.75,2.41-0.75,3.72     c0,1.31,0.25,2.56,0.75,3.72c0.5,1.17,1.19,2.19,2.06,3.07s1.9,1.56,3.07,2.06c1.17,0.5,2.42,0.75,3.76,0.75     c1.24,0,2.44-0.23,3.6-0.69c1.16-0.46,2.18-1.12,3.08-1.97l3.4,3.39c-1.36,1.31-2.91,2.33-4.64,3.03     c-1.73,0.7-3.54,1.06-5.44,1.06c-2,0-3.87-0.38-5.62-1.13c-1.75-0.75-3.29-1.78-4.6-3.08c-1.31-1.3-2.35-2.83-3.1-4.58     c-0.75-1.75-1.13-3.63-1.13-5.62c0-2,0.38-3.87,1.13-5.62c0.75-1.75,1.79-3.28,3.1-4.58c1.31-1.3,2.85-2.33,4.6-3.08     c1.75-0.75,3.63-1.13,5.62-1.13c1.9,0,3.71,0.35,5.44,1.06C264.49,447.98,266.04,448.99,267.4,450.31z",
    id: "path21",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.56,474.7h-4.75v-11.68h-10.26v11.68h-4.75v-28.11h4.75v11.68h10.26v-11.68h4.75V474.7z",
    id: "path23",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "A_1_",
    className: "st0",
    points: "360.77,445.48 347.98,474.71 353.17,474.71 360.77,457.32 368.37,474.71 373.56,474.71         ",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.82,474.7h-17.52v-28.11h17.52v4.75h-12.78v6.94h11.32v4.75h-11.32v6.94h12.78V474.7z",
    id: "path26",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.17,474.7h-4.75v-14.71l-8.63,11.21l-8.63-11.21v14.71h-4.75v-29.21l13.38,18.29l13.38-18.29V474.7z",
    id: "path28",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.2,450.31l-3.4,3.4c-0.9-0.85-1.93-1.51-3.08-1.97c-1.16-0.46-2.35-0.69-3.6-0.69     c-1.34,0-2.59,0.25-3.76,0.75c-1.17,0.5-2.19,1.19-3.07,2.06c-0.88,0.88-1.56,1.9-2.06,3.07c-0.5,1.17-0.75,2.41-0.75,3.72     c0,1.31,0.25,2.56,0.75,3.72c0.5,1.17,1.19,2.19,2.06,3.07s1.9,1.56,3.07,2.06c1.17,0.5,2.42,0.75,3.76,0.75     c1.24,0,2.44-0.23,3.6-0.69c1.16-0.46,2.18-1.12,3.08-1.97l3.4,3.39c-1.36,1.31-2.91,2.33-4.64,3.03     c-1.73,0.7-3.54,1.06-5.44,1.06c-2,0-3.87-0.38-5.62-1.13c-1.75-0.75-3.29-1.78-4.6-3.08c-1.31-1.3-2.35-2.83-3.1-4.58     c-0.75-1.75-1.13-3.63-1.13-5.62c0-2,0.38-3.87,1.13-5.62c0.75-1.75,1.79-3.28,3.1-4.58c1.31-1.3,2.85-2.33,4.6-3.08     c1.75-0.75,3.63-1.13,5.62-1.13c1.9,0,3.71,0.35,5.44,1.06C395.29,447.98,396.84,448.99,398.2,450.31z",
    id: "path30",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.36,474.7h-4.75v-11.68h-10.26v11.68h-4.75v-28.11h4.75v11.68h10.26v-11.68h4.75V474.7z",
    id: "path32",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.62,474.7h-17.52v-28.11h17.52v4.75h-12.78v6.94h11.32v4.75h-11.32v6.94h12.78V474.7z",
    id: "path34",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M468.67,474.7h-5.48l-5.84-11.68h-3.4v11.68h-4.75v-28.11h11.06c1.12,0,2.18,0.21,3.18,0.64     c1,0.43,1.87,1.02,2.63,1.77s1.34,1.63,1.77,2.63s0.64,2.06,0.64,3.18c0,0.93-0.15,1.81-0.44,2.67     c-0.29,0.85-0.71,1.62-1.24,2.32c-0.54,0.69-1.17,1.3-1.92,1.81c-0.74,0.51-1.56,0.89-2.46,1.13L468.67,474.7z M463.74,454.8     c0-0.46-0.09-0.91-0.27-1.33c-0.18-0.42-0.43-0.8-0.75-1.11c-0.32-0.32-0.69-0.57-1.11-0.75c-0.43-0.18-0.87-0.27-1.33-0.27     h-6.32v6.94h6.32c0.46,0,0.91-0.09,1.33-0.27s0.8-0.43,1.11-0.75c0.32-0.32,0.57-0.68,0.75-1.1     C463.65,455.74,463.74,455.29,463.74,454.8z",
    id: "path36",
    style: {
      fill: "#000000"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Balken_4_",
    x: 88.52,
    y: 423.49,
    className: "st0",
    width: 389.89,
    height: 2.79,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x26__2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.45,220.01l-9.33,9.42l9.16,9.33l-7.15,7.24l-9.16-9.24l-2.44,2.53c-2.04,2.04-4.37,3.62-7.02,4.75    c-2.65,1.13-5.42,1.7-8.33,1.7c-3.08,0-5.93-0.58-8.55-1.74c-2.62-1.16-4.91-2.75-6.89-4.75c-1.98-2.01-3.52-4.34-4.62-7.02    c-1.1-2.67-1.66-5.52-1.66-8.54c0-2.96,0.55-5.8,1.66-8.5c1.1-2.7,2.67-5.1,4.71-7.19l2.53-2.62c-2.09-3.08-3.14-6.42-3.14-10.03    c0-2.21,0.41-4.3,1.22-6.28c0.81-1.98,1.95-3.69,3.4-5.14c1.45-1.45,3.15-2.6,5.1-3.44c1.95-0.84,4.02-1.26,6.23-1.26    c2.09,0,4.08,0.39,5.97,1.18c1.89,0.78,3.55,1.86,4.97,3.23c1.42,1.37,2.56,2.96,3.4,4.8c0.84,1.83,1.26,3.82,1.26,5.97    c0,2.21-0.41,4.35-1.22,6.41c-0.82,2.06-1.8,4.03-2.96,5.88l-7.24-7.24c0.41-0.7,0.76-1.45,1.05-2.27    c0.29-0.81,0.44-1.63,0.44-2.44c0-1.51-0.58-2.76-1.74-3.75c-1.16-0.99-2.47-1.48-3.92-1.48c-1.69,0-3.11,0.58-4.27,1.74    c-1.16,1.16-1.74,2.59-1.74,4.27c0,1.69,0.58,3.11,1.74,4.27l22.06,22.41l9.33-9.42L311.45,220.01z M287.82,229.42l-16.39-16.65    c-0.87,0.87-1.67,1.69-2.4,2.44c-0.73,0.76-1.35,1.54-1.87,2.35c-0.52,0.81-0.93,1.72-1.22,2.7c-0.29,0.99-0.44,2.12-0.44,3.4    c0,1.57,0.31,3.07,0.92,4.49c0.61,1.42,1.44,2.67,2.49,3.75c1.05,1.08,2.28,1.93,3.71,2.57c1.42,0.64,2.95,0.96,4.58,0.96    c1.28,0,2.4-0.16,3.36-0.48c0.96-0.32,1.85-0.74,2.66-1.26c0.81-0.52,1.58-1.15,2.31-1.87    C286.24,231.1,287.01,230.3,287.82,229.42z",
    id: "path42",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "BALKEN_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.35,
    y: 208.52,
    className: "st0",
    width: 173.08,
    height: 8.24,
    id: "rect45",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.5,
    y: 208.52,
    className: "st0",
    width: 173.08,
    height: 8.24,
    id: "rect47",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "HARMONIE_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.58,353.63h-11.8V324.6h-25.5v29.04h-11.8v-69.87h11.8v29.03h25.5v-29.03h11.8V353.63z",
    id: "path50",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.11,281.05 109.35,353.63 122.24,353.63 141.11,310.44 159.98,353.63 172.87,353.63     ",
    id: "polygon52",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.95,353.63h-13.61l-14.52-29.04h-8.44v29.04h-11.8v-69.87h27.49c2.78,0,5.41,0.53,7.89,1.59     c2.48,1.06,4.66,2.53,6.53,4.4c1.87,1.88,3.34,4.05,4.4,6.53c1.06,2.48,1.59,5.11,1.59,7.89c0,2.3-0.36,4.51-1.09,6.62     c-0.73,2.12-1.75,4.04-3.08,5.76c-1.33,1.72-2.92,3.22-4.76,4.49c-1.85,1.27-3.89,2.21-6.12,2.81L223.95,353.63z M211.7,304.18     c0-1.15-0.23-2.25-0.68-3.31c-0.45-1.06-1.07-1.98-1.86-2.77c-0.79-0.79-1.71-1.41-2.77-1.86c-1.06-0.45-2.16-0.68-3.31-0.68     h-15.7v17.24h15.7c1.15,0,2.25-0.23,3.31-0.68c1.06-0.45,1.98-1.07,2.77-1.86c0.79-0.79,1.41-1.69,1.86-2.72     C211.47,306.51,211.7,305.4,211.7,304.18z",
    id: "path56",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.5,353.63h-11.8v-36.57l-21.46,27.86l-21.46-27.86v36.57h-11.8v-72.59l33.25,45.46l33.25-45.46V353.63z",
    id: "path58",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.87,318.7c0,4.96-0.94,9.62-2.81,13.97c-1.88,4.36-4.43,8.15-7.67,11.39     c-3.24,3.24-7.03,5.79-11.39,7.67c-4.36,1.88-9.01,2.81-13.97,2.81c-4.96,0-9.62-0.94-13.97-2.81     c-4.35-1.87-8.15-4.43-11.39-7.67c-3.24-3.23-5.79-7.03-7.67-11.39c-1.88-4.35-2.81-9.01-2.81-13.97c0-4.96,0.94-9.62,2.81-13.97     c1.87-4.35,4.43-8.15,7.67-11.39c3.23-3.24,7.03-5.79,11.39-7.67c4.36-1.87,9.01-2.81,13.97-2.81c4.96,0,9.62,0.94,13.97,2.81     c4.35,1.88,8.15,4.43,11.39,7.67c3.24,3.24,5.79,7.03,7.67,11.39C372.93,309.08,373.87,313.74,373.87,318.7z M361.89,318.7     c0-3.27-0.62-6.35-1.86-9.25c-1.24-2.9-2.95-5.44-5.13-7.62c-2.18-2.18-4.72-3.89-7.62-5.13c-2.9-1.24-5.99-1.86-9.25-1.86     s-6.35,0.62-9.25,1.86c-2.9,1.24-5.44,2.95-7.62,5.13c-2.18,2.18-3.89,4.72-5.13,7.62c-1.24,2.9-1.86,5.99-1.86,9.25     c0,3.27,0.62,6.35,1.86,9.26c1.24,2.9,2.95,5.44,5.13,7.62c2.18,2.18,4.72,3.89,7.62,5.13c2.9,1.24,5.99,1.86,9.25,1.86     s6.35-0.62,9.25-1.86c2.9-1.24,5.44-2.95,7.62-5.13c2.18-2.18,3.89-4.72,5.13-7.62C361.27,325.05,361.89,321.97,361.89,318.7z",
    id: "path60",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.35,356.54l-42.01-45.55v42.65h-11.8v-72.59l42.01,45.55v-42.65h11.8V356.54z",
    id: "path62",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.02,353.63h-11.8v-69.87h11.8V353.63z",
    id: "path64",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.44,353.63h-43.55v-69.87h43.55v11.8h-31.76v17.24h28.13v11.8h-28.13v17.24h31.76V353.63z",
    id: "path66",
    style: {
      fill: "#000000"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "GENUSS_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.81,130.62l-0.18,0.54c-3.35,3.23-7.15,5.71-11.39,7.45c-4.25,1.73-8.7,2.6-13.37,2.6    c-4.91,0-9.51-0.93-13.82-2.78c-4.31-1.85-8.08-4.38-11.3-7.58c-3.23-3.2-5.77-6.95-7.63-11.26c-1.85-4.31-2.78-8.91-2.78-13.82    c0-4.9,0.93-9.51,2.78-13.82c1.85-4.31,4.4-8.06,7.63-11.26c3.23-3.2,7-5.73,11.3-7.58c4.31-1.85,8.91-2.78,13.82-2.78    c4.67,0,9.12,0.87,13.37,2.6c4.25,1.74,8.04,4.22,11.39,7.45l-8.34,8.34c-2.21-2.09-4.74-3.71-7.58-4.85    c-2.84-1.14-5.79-1.7-8.84-1.7c-3.29,0-6.37,0.61-9.24,1.84c-2.87,1.23-5.38,2.92-7.54,5.07c-2.15,2.15-3.84,4.67-5.07,7.54    c-1.23,2.87-1.84,5.92-1.84,9.15c0,3.23,0.61,6.28,1.84,9.15c1.23,2.87,2.92,5.38,5.07,7.54c2.15,2.15,4.67,3.84,7.54,5.07    c2.87,1.23,5.95,1.84,9.24,1.84c2.51,0,4.96-0.37,7.36-1.12c2.39-0.75,4.63-1.9,6.73-3.45V111.6h-14V99.93h24.85V130.62z",
    id: "path71",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.85,140.31h-43.07V71.22h43.07v11.66h-31.4v17.05h27.81v11.66h-27.81v17.05h31.4V140.31z",
    id: "path73",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.97,143.18l-41.54-45.04v42.17h-11.66V68.53l41.54,45.04V71.4h11.66V143.18z",
    id: "path75",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.28,113.93c0,3.77-0.72,7.3-2.15,10.59c-1.08,2.51-2.47,4.8-4.17,6.86c-1.7,2.06-3.66,3.83-5.88,5.29    c-2.21,1.47-4.59,2.59-7.13,3.36c-2.54,0.78-5.19,1.17-7.94,1.17c-3.77,0-7.31-0.72-10.63-2.15c-3.32-1.44-6.21-3.38-8.66-5.83    c-2.45-2.45-4.4-5.34-5.83-8.66s-2.15-6.86-2.15-10.63V71.22h11.66v42.71c0,2.15,0.4,4.17,1.21,6.06    c0.81,1.88,1.93,3.54,3.36,4.98c1.44,1.44,3.1,2.56,4.98,3.36c1.88,0.81,3.9,1.21,6.06,1.21c2.15,0,4.17-0.4,6.06-1.21    c1.88-0.81,3.54-1.93,4.98-3.36c1.44-1.44,2.56-3.1,3.36-4.98c0.81-1.88,1.21-3.9,1.21-6.06V71.22h11.66V113.93z",
    id: "path77",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.48,121.2c0,3.17-0.63,6-1.88,8.48c-1.26,2.48-2.93,4.58-5.02,6.28c-2.09,1.7-4.52,3.01-7.27,3.9    c-2.75,0.9-5.62,1.35-8.61,1.35c-5.02,0-9.33-1.4-12.92-4.22c-3.59-2.81-6.16-6.55-7.72-11.22l9.87-4.4    c0.84,2.33,1.96,4.14,3.36,5.43c1.4,1.29,2.92,2.17,4.53,2.65c1.61,0.48,3.26,0.58,4.93,0.31c1.67-0.27,3.18-0.79,4.53-1.57    c1.35-0.78,2.44-1.78,3.28-3.01c0.84-1.23,1.26-2.56,1.26-3.99c0-1.85-0.69-3.41-2.06-4.67c-1.38-1.26-3.11-2.45-5.2-3.59    c-2.09-1.14-4.35-2.29-6.77-3.45c-2.42-1.17-4.68-2.59-6.77-4.26c-2.09-1.67-3.83-3.69-5.2-6.06c-1.38-2.36-2.06-5.31-2.06-8.84    c0-2.69,0.49-5.23,1.48-7.63c0.99-2.39,2.36-4.52,4.13-6.37c1.76-1.85,3.83-3.32,6.19-4.4c2.36-1.08,4.89-1.62,7.58-1.62    c4.31,0,8.07,1.09,11.3,3.27c3.23,2.18,5.71,5.22,7.45,9.11l-10.14,4.67c-1.14-2.39-2.68-4.01-4.62-4.85    c-1.94-0.84-3.84-1.06-5.7-0.67c-1.85,0.39-3.47,1.33-4.84,2.83c-1.38,1.5-2.06,3.38-2.06,5.65c0,1.79,0.72,3.32,2.15,4.58    c1.44,1.26,3.23,2.42,5.38,3.5c2.15,1.08,4.47,2.21,6.95,3.41c2.48,1.2,4.8,2.63,6.95,4.31c2.15,1.68,3.95,3.72,5.38,6.15    C403.77,114.69,404.48,117.67,404.48,121.2z",
    id: "path79",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.59,121.2c0,3.17-0.63,6-1.88,8.48c-1.26,2.48-2.93,4.58-5.02,6.28c-2.09,1.7-4.52,3.01-7.27,3.9    c-2.75,0.9-5.62,1.35-8.61,1.35c-5.02,0-9.33-1.4-12.92-4.22c-3.59-2.81-6.16-6.55-7.72-11.22l9.87-4.4    c0.84,2.33,1.96,4.14,3.36,5.43c1.4,1.29,2.92,2.17,4.53,2.65c1.61,0.48,3.26,0.58,4.93,0.31c1.67-0.27,3.18-0.79,4.53-1.57    c1.35-0.78,2.44-1.78,3.28-3.01c0.84-1.23,1.26-2.56,1.26-3.99c0-1.85-0.69-3.41-2.06-4.67c-1.38-1.26-3.11-2.45-5.2-3.59    c-2.09-1.14-4.35-2.29-6.77-3.45c-2.42-1.17-4.68-2.59-6.77-4.26c-2.09-1.67-3.83-3.69-5.2-6.06c-1.38-2.36-2.06-5.31-2.06-8.84    c0-2.69,0.49-5.23,1.48-7.63c0.99-2.39,2.36-4.52,4.13-6.37c1.76-1.85,3.83-3.32,6.19-4.4c2.36-1.08,4.89-1.62,7.58-1.62    c4.31,0,8.07,1.09,11.3,3.27c3.23,2.18,5.71,5.22,7.45,9.11l-10.14,4.67c-1.14-2.39-2.68-4.01-4.62-4.85    c-1.94-0.84-3.84-1.06-5.7-0.67c-1.85,0.39-3.47,1.33-4.84,2.83c-1.38,1.5-2.06,3.38-2.06,5.65c0,1.79,0.72,3.32,2.15,4.58    c1.44,1.26,3.23,2.42,5.38,3.5c2.15,1.08,4.47,2.21,6.95,3.41c2.48,1.2,4.8,2.63,6.95,4.31c2.15,1.68,3.95,3.72,5.38,6.15    C450.87,114.69,451.59,117.67,451.59,121.2z",
    id: "path81",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 7,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "rect4613",
    width: 566.92999,
    height: 566.92999,
    x: 0,
    y: -0.31
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGandhLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gandh-logo.0dcf7e5f.svg";
export { ForwardRef as ReactComponent };